import React from 'react';
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
} from 'react-router-dom';
/* Imports :: Config */
import config from './config';

/* Imports :: Components */
import Home from './pages/Home';
import Document from './pages/Document';
import SignUp from './pages/SignUp';
import Login from './pages/Login';
import ResetPassword from './pages/ResetPassword';
import ConfirmEmailPage from './pages/ConfirmEmail';
import MyAccount from './pages/MyAccount';
import BookmarksPage from './pages/Bookmarks';
import SelectPlans from './pages/SelectPlans';
import SearchPage from './pages/Search';
import Persistence from './Persistence';
import Query from './pages/Query';

import ApiSignUp from './pages/ApiSignUp';
import ApiActivate from './pages/ApiActivate';
import ApiHome from './pages/ApiHome';
import ApiKeys from './pages/ApiKeys';
import ApiUserAccount from './pages/ApiUserAccount';
import ApiBilling from './pages/ApiBilling';
import ApiAdmin from './pages/ApiAdmin';

const AppRoute = () => {
  return (
    <React.Fragment>
      <Router>
        <Switch>
          <Route
            path='/app/my-account/update-subscription'
            exact
            component={() => (
              <Persistence>
                <SelectPlans />
              </Persistence>
            )}
          />
          <Route
            path='/app/my-account/select-plans'
            exact
            component={() => (
              <Persistence>
                <SelectPlans />
              </Persistence>
            )}
          />
          <Route
            path='/app/my-account/:page'
            component={() => (
              <Persistence>
                <MyAccount />
              </Persistence>
            )}
          />
          <Route
            path='/app/my-bookmarks'
            exact
            component={() => (
              <Persistence>
                <BookmarksPage />
              </Persistence>
            )}
          />
          <Route
            path='/app/queries'
            exact
            component={() => (
              <Persistence>
                <Query />
              </Persistence>
            )}
          />
          <Route
            path='/app/account/confirm-email/:userID/:token+'
            component={ConfirmEmailPage}
          />
          <Route
            path='/app/account/confirm-email'
            component={ConfirmEmailPage}
          />
          <Route
            path='/app/account/reset-password/:email/:token+'
            component={ResetPassword}
          />
          <Route
            path='/app/account/reset-password/'
            component={ResetPassword}
          />
          <Route path='/app/account/register/' component={SignUp} />
          <Route
            path='/app/account/login/:id?'
            component={() => (
              <Persistence>
                <Login />
              </Persistence>
            )}
          />
          {/* <Route
            path='/app/search/:searchParam'
            component={() => (
              <Persistence>
                <SearchPage />
              </Persistence>
            )}
          /> */}
          <Route
            path='/app/search'
            exact
            component={() => (
              <Persistence>
                <SearchPage />
              </Persistence>
            )}
          />
          {/* <Route path="/app/:levelOne/:levelTwo/:levelThree/:document" component={() => (
            <Persistence>
              <Document />
            </Persistence>
          )} />
          <Route path="/app/:levelOne/:levelTwo/:document/:page" component={() => (
            <Persistence>
              <Document />
            </Persistence>
          )} /> */}
          <Route
            path='/app/:docSlug/:pageSlug/:scrollItem'
            component={() => (
              <Persistence>
                <Document />
              </Persistence>
            )}
          />
          <Route
            path='/app/:docSlug/:pageSlug'
            component={() => (
              <Persistence>
                <Document />
              </Persistence>
            )}
          />
          <Route
            path='/app/:docSlug'
            component={() => (
              <Persistence>
                <Document />
              </Persistence>
            )}
          />
          <Route
            path={config.HomeURL}
            exact
            component={() => (
              <Persistence>
                <Home />
              </Persistence>
            )}
          />

          {/* ROUTES FOR REG CITY API */}
          {/* Bare /api (and /api/) have no section to match /api/:section/ below,
              which would render nothing. Send them to the portal home instead. */}
          <Route path='/api' exact>
            <Redirect to='/api/overview' />
          </Route>
          <Route path='/api/signup/' component={ApiSignUp} />
          <Route path='/api/activate' exact component={() => (
            <Persistence>
              <ApiActivate />
            </Persistence>
          )} />
          <Route path='/api/account-settings/:page' component={() => (
            <Persistence>
              <ApiUserAccount />
            </Persistence>
          )} />
          <Route path='/api/billing-usage/:page' component={() => (
            <Persistence>
              <ApiBilling />
            </Persistence>
          )} />
          <Route path='/api/api-keys/' component={() => (
            <Persistence>
              <ApiKeys />
            </Persistence>
          )} />
          <Route path='/api/admin/:page?/:id?' component={() => (
            <Persistence>
              <ApiAdmin />
            </Persistence>
          )} />
          <Route path='/api/:section/' component={() => (
            <Persistence>
              <ApiHome />
            </Persistence>
          )} />
        </Switch>
      </Router>
    </React.Fragment>
  );
};

export default AppRoute;
